import React from 'react';
import axios from 'axios';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// NOUVEAU: on ajoute orderId en paramètre
const CheckoutStripe = ({ amount, orderId }) => {
  const { deviseInfo } = useSelector((state) => state.devise);

  const handleCheckout = async () => {
    try {
      // On envoie le montant, la devise ET l'ID de la commande
      const response = await axios.post('/api/create-checkout-session', {
        amount: Math.round(amount * 100), 
        currency: deviseInfo.toLowerCase(),
        orderId: orderId 
      });
      window.location.href = response.data.url;
    } catch (error) {
      console.error('Error creating checkout session', error);
    }
  };

  return (
    <Container>
      <Row className='justify-content-md-center'>
        <Col md={12}>
          <Form>
            <Button variant='primary' className="w-100 mt-3" onClick={handleCheckout}>
              Payer {amount} {deviseInfo === 'EUR' ? '€' : '$'} avec Stripe
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default CheckoutStripe;